module.exports = __webpack_public_path__ + "media/newstyle/images/metadata-57a9f0b6cf3b7229c3ba09429420c9b8.png";